webpackJsonp([128494480927300],{

/***/ 113:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(19);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PortfolioGrid = function PortfolioGrid(_ref) {
	  var title = _ref.title,
	      items = _ref.items,
	      categorySlug = _ref.categorySlug;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio-title' },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio-grid' },
	      items.map(function (item) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'portfolio-grid-item', key: item.slug },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: categorySlug + item.slug },
	            _react2.default.createElement(_gatsbyImage2.default, { sizes: item.thumbnailSizes })
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = PortfolioGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PortfolioGrid = __webpack_require__(82);
	
	var _PortfolioGrid2 = _interopRequireDefault(_PortfolioGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPage = function SocialPage(_ref) {
	  var data = _ref.data;
	
	  var items = data.allFile.edges.map(function (item) {
	    return item.node.fullImage === null ? null : {
	      fullSizes: item.node.fullImage.sizes,
	      thumbnailSizes: item.node.thumbnail.sizes,
	      name: item.node.name,
	      slug: item.node.fields.slug
	    };
	  }).filter(function (item) {
	    return item !== null;
	  });
	
	  return _react2.default.createElement(_PortfolioGrid2.default, {
	    items: items,
	    title: 'social media',
	    categorySlug: '/socialmedia'
	  });
	};
	
	exports.default = SocialPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-socialmedia-index-js-1f66c257050856d20214.js